import { createI18n } from 'vue-i18n'

import en from "~/config/locales/en.js"
import zh from "~/config/locales/zh.js"

const i18n = createI18n({
  locale: 'zh',
  fallbackLocale: 'zh',
  messages: {
    en,
    zh
  }
});

export default i18n;